const { ipcRenderer } = window.require('electron')
import { FuncJs } from './func.js'

export function sendExec(func, model,wait_reply=true) {
    return new Promise((resolve) => {
        ipcRenderer.once(`${func}-reply`, (event, result) => {
            resolve(result)
        })
        ipcRenderer.send('exec', { js: FuncJs.toString(), func, model })
    })
}
